import { APP_INITIALIZER } from '@angular/core';
import { Store } from '@ngrx/store';
import { GetOperatorsScripts } from '@store/customization/customization.actions';

export const provideOperatorScriptsAction = () => ({
  provide: APP_INITIALIZER,
  useFactory: (store: Store) => () => store.dispatch(new GetOperatorsScripts()),
  deps: [Store],
  multi: true
});
